import { AgeRestriction } from '@diritto/common/content/constants';
import { UserMeDto } from '@diritto/common/account/dtos/user-me.dto';
import { UseClientType } from '@diritto/common/utils/userAgent';

export enum AccessBlockCode {
  AuthorizationAdultRequired = 'AuthorizationAdultRequired',
  AuthorizationOver15YearsOldRequired = 'AuthorizationOver15YearsOldRequired',
  AgeVerifiedRequired = 'AgeVerifiedRequired',
  Over15YearsOldRequired = 'Over15YearsOldRequired',
  AdultRequired = 'AdultRequired',
  HiddenContents = 'HiddenContents',
}

export const checkAdultAccessBlock = (user?: UserMeDto, ageRestriction?: AgeRestriction) => {
  if (ageRestriction === AgeRestriction.Adult) {
    if (!user) {
      return AccessBlockCode.AuthorizationAdultRequired;
    }

    if (!user.ageVerified) {
      return AccessBlockCode.AgeVerifiedRequired;
    }

    if (!user.isAdult) {
      return AccessBlockCode.AdultRequired;
    }
  }

  if (ageRestriction === AgeRestriction.Fifteen) {
    if (!user) {
      return AccessBlockCode.AuthorizationOver15YearsOldRequired;
    }

    if (!user.ageVerified) {
      return AccessBlockCode.AgeVerifiedRequired;
    }

    if (!user.isOver15YearsOld) {
      return AccessBlockCode.Over15YearsOldRequired;
    }
  }

  return undefined;
};

export const checkHiddenContentsAccessBlock = (
  content: { isHiddenContents: boolean },
  episode: {
    isNotice: boolean;
  },
) => (content.isHiddenContents && !episode.isNotice ? AccessBlockCode.HiddenContents : undefined);

export const checkIncludeAdult = (client: UseClientType, user: UserMeDto | undefined) => {
  // 비 로그인 사용자는 목록에서 19 제거
  if (!user) {
    return false;
  }

  // iOS 안드, 웹에서는 목록에서 유저의 성인 여부에 따라 19 제거
  return user.isAdult;
};
